const initMapWithOneMarker = ({ apiKey, mapId, lat, lng, iconUrl, customMarker }) => {
  $(`#${mapId}`).one('click', (e) => {
    $(this).css('background-image', 'none');

    const streets = L.tileLayer.Unwired({ key: apiKey, scheme: 'streets' });

    const map = L.map(mapId, {
      center: [lat, lng],
      zoom: 15,
      maxZoom: 15,
      minZoom: 10,
      layers: [streets],
    });

    L.control.scale({ imperial: false }).addTo(map);
    let icon = '';

    if (customMarker.length !== 0) {
      icon = L.divIcon({
        iconSize: [35, 35],
        iconAnchor: [17, 35],
        className: '',
        html: customMarker,
      });
    } else {
      icon = L.icon({
        iconUrl,
        iconSize: [35, 35],
        iconAnchor: [17, 35],
      });
    }

    L.marker(new L.LatLng(lat, lng), { icon }).addTo(map);
  });
};

export { initMapWithOneMarker };
